import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import useS3FileManagement from "../Hooks/useS3FileManagement";
import AlertContext from "../context/AlertContext";
import Loading from "./Notification-Loading/Loading/Loading.js";
import { adminEmailBody } from "../util";
import Button from "./Button";
import InputField from "./CommonComponents/InputField";
import DragAndDropUpload from "./CommonComponents/DragAndDropUpload";
import ToggleButton from "./CommonComponents/ToggleButton";
import Checkbox from "./CommonComponents/Checkbox";
import InputDropdown from "./CommonComponents/InputDropdown";
import PhoneInput from "react-phone-input-2";
import IconButton from "./CommonComponents/IconButton.js";
import UserValidationHook from "../Hooks/UserValidationHook.js";
import Toast from "./CommonComponents/Toast.js";
import constants from "../constants";

// ─── SVG Icons (unchanged) ──────────────────────────────────────────────────
const AddadminplusIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.33333 6V12.6667M6 9.33333H12.6667M17.6667 9.33333C17.6667 13.9357 13.9357 17.6667 9.33333 17.6667C4.73096 17.6667 1 13.9357 1 9.33333C1 4.73096 4.73096 1 9.33333 1C13.9357 1 17.6667 4.73096 17.6667 9.33333Z" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

const EmailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3346 5.00001C18.3346 4.08334 17.5846 3.33334 16.668 3.33334H3.33464C2.41797 3.33334 1.66797 4.08334 1.66797 5.00001M18.3346 5.00001V15C18.3346 15.9167 17.5846 16.6667 16.668 16.6667H3.33464C2.41797 16.6667 1.66797 15.9167 1.66797 15V5.00001M18.3346 5.00001L10.0013 10.8333L1.66797 5.00001" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

const LocationIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#F2F4F7" />
    <path d="M15.9987 16.0001C16.3195 16.0001 16.5942 15.8858 16.8227 15.6574C17.0511 15.4289 17.1654 15.1542 17.1654 14.8334C17.1654 14.5126 17.0511 14.2379 16.8227 14.0095C16.5942 13.781 16.3195 13.6667 15.9987 13.6667C15.6779 13.6667 15.4032 13.781 15.1747 14.0095C14.9463 14.2379 14.832 14.5126 14.832 14.8334C14.832 15.1542 14.9463 15.4289 15.1747 15.6574C15.4032 15.8858 15.6779 16.0001 15.9987 16.0001ZM15.9987 20.2876C17.1848 19.1987 18.0647 18.2095 18.6383 17.3199C19.2119 16.4303 19.4987 15.6404 19.4987 14.9501C19.4987 13.8904 19.1609 13.0227 18.4852 12.347C17.8095 11.6713 16.9806 11.3334 15.9987 11.3334C15.0168 11.3334 14.1879 11.6713 13.5122 12.347C12.8365 13.0227 12.4987 13.8904 12.4987 14.9501C12.4987 15.6404 12.7855 16.4303 13.3591 17.3199C13.9327 18.2095 14.8126 19.1987 15.9987 20.2876ZM15.9987 21.8334C14.4334 20.5015 13.2643 19.2643 12.4914 18.122C11.7185 16.9796 11.332 15.9223 11.332 14.9501C11.332 13.4917 11.8011 12.3299 12.7393 11.4647C13.6775 10.5994 14.764 10.1667 15.9987 10.1667C17.2334 10.1667 18.3199 10.5994 19.2581 11.4647C20.1963 12.3299 20.6654 13.4917 20.6654 14.9501C20.6654 15.9223 20.2789 16.9796 19.506 18.122C18.7331 19.2643 17.564 20.5015 15.9987 21.8334Z" fill="#667085" />
  </svg>
);

const CollegeIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#F2F4F7" />
    <path d="M15.9987 15.9999C15.357 15.9999 14.8077 15.7714 14.3508 15.3145C13.8938 14.8576 13.6654 14.3083 13.6654 13.6666C13.6654 13.0249 13.8938 12.4756 14.3508 12.0187C14.8077 11.5617 15.357 11.3333 15.9987 11.3333C16.6404 11.3333 17.1897 11.5617 17.6466 12.0187C18.1036 12.4756 18.332 13.0249 18.332 13.6666C18.332 14.3083 18.1036 14.8576 17.6466 15.3145C17.1897 15.7714 16.6404 15.9999 15.9987 15.9999ZM11.332 20.6666V19.0333C11.332 18.7027 11.4171 18.3989 11.5872 18.1218C11.7574 17.8447 11.9834 17.6333 12.2654 17.4874C12.8681 17.186 13.4806 16.96 14.1029 16.8093C14.7251 16.6586 15.357 16.5833 15.9987 16.5833C16.6404 16.5833 17.2723 16.6586 17.8945 16.8093C18.5168 16.96 19.1293 17.186 19.732 17.4874C20.014 17.6333 20.24 17.8447 20.4102 18.1218C20.5803 18.3989 20.6654 18.7027 20.6654 19.0333V20.6666H11.332Z" fill="#667085" />
  </svg>
);

const FeaturesIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#F2F4F7" />
    <path d="M10.7487 22.4166V19.9666C10.4084 19.8499 10.1289 19.6433 9.91016 19.3468C9.69141 19.0503 9.58203 18.7124 9.58203 18.3333V12.4999H10.7487V10.1666C10.7487 10.0013 10.8046 9.86277 10.9164 9.75096C11.0282 9.63915 11.1668 9.58325 11.332 9.58325C11.4973 9.58325 11.6359 9.63915 11.7477 9.75096C11.8595 9.86277 11.9154 10.0013 11.9154 10.1666V12.4999H13.082V18.3333C13.082 18.7124 12.9727 19.0503 12.7539 19.3468C12.5352 19.6433 12.2556 19.8499 11.9154 19.9666V22.4166H10.7487ZM15.4154 22.4166V19.9666C15.0751 19.8499 14.7956 19.6433 14.5768 19.3468C14.3581 19.0503 14.2487 18.7124 14.2487 18.3333V12.4999H15.4154V10.1666C15.4154 10.0013 15.4713 9.86277 15.5831 9.75096C15.6949 9.63915 15.8334 9.58325 15.9987 9.58325C16.164 9.58325 16.3025 9.63915 16.4143 9.75096C16.5261 9.86277 16.582 10.0013 16.582 10.1666V12.4999H17.7487V18.3333C17.7487 18.7124 17.6393 19.0503 17.4206 19.3468C17.2018 19.6433 16.9223 19.8499 16.582 19.9666V22.4166H15.4154ZM20.082 22.4166V19.9666C19.7418 19.8499 19.4622 19.6433 19.2435 19.3468C19.0247 19.0503 18.9154 18.7124 18.9154 18.3333V12.4999H20.082V10.1666C20.082 10.0013 20.1379 9.86277 20.2497 9.75096C20.3615 9.63915 20.5001 9.58325 20.6654 9.58325C20.8306 9.58325 20.9692 9.63915 21.081 9.75096C21.1928 9.86277 21.2487 10.0013 21.2487 10.1666V12.4999H22.4154V18.3333C22.4154 18.7124 22.306 19.0503 22.0872 19.3468C21.8685 19.6433 21.589 19.8499 21.2487 19.9666V22.4166H20.082ZM10.7487 13.6666V15.9999H11.9154V13.6666H10.7487ZM15.4154 13.6666V15.9999H16.582V13.6666H15.4154ZM20.082 13.6666V15.9999H21.2487V13.6666H20.082ZM11.332 18.9166C11.4973 18.9166 11.6359 18.8607 11.7477 18.7489C11.8595 18.6371 11.9154 18.4985 11.9154 18.3333V17.1666H10.7487V18.3333C10.7487 18.4985 10.8046 18.6371 10.9164 18.7489C11.0282 18.8607 11.1668 18.9166 11.332 18.9166ZM15.9987 18.9166C16.164 18.9166 16.3025 18.8607 16.4143 18.7489C16.5261 18.6371 16.582 18.4985 16.582 18.3333V17.1666H15.4154V18.3333C15.4154 18.4985 15.4713 18.6371 15.5831 18.7489C15.6949 18.8607 15.8334 18.9166 15.9987 18.9166ZM20.6654 18.9166C20.8306 18.9166 20.9692 18.8607 21.081 18.7489C21.1928 18.6371 21.2487 18.4985 21.2487 18.3333V17.1666H20.082V18.3333C20.082 18.4985 20.1379 18.6371 20.2497 18.7489C20.3615 18.8607 20.5001 18.9166 20.6654 18.9166Z" fill="#667085" />
  </svg>
);

const SectionHeader = ({ icon, title }) => (
  <div className="oa-section-header">
    <div className="oa-section-title-group">
      <div className="oa-section-icon">{icon}</div>
      <h3 className="oa-section-title">{title}</h3>
    </div>
  </div>
);

const UploadImage = () => (
  <svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.75 21.25H11.25V16.0312L13.25 18.0312L15 16.25L10 11.25L5 16.25L6.78125 18L8.75 16.0312V21.25ZM2.5 25C1.8125 25 1.22396 24.7552 0.734375 24.2656C0.244792 23.776 0 23.1875 0 22.5V2.5C0 1.8125 0.244792 1.22396 0.734375 0.734375C1.22396 0.244792 1.8125 0 2.5 0H12.5L20 7.5V22.5C20 23.1875 19.7552 23.776 19.2656 24.2656C18.776 24.7552 18.1875 25 17.5 25H2.5ZM11.25 8.75V2.5H2.5V22.5H17.5V8.75H11.25ZM2.5 2.5V8.75V2.5V8.75V22.5V2.5Z" fill="#F55533" />
  </svg>
);

const DeleteIconSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 4.99996H4.16667M4.16667 4.99996H17.5M4.16667 4.99996V16.6666C4.16667 17.1087 4.34226 17.5326 4.65482 17.8451C4.96738 18.1577 5.39131 18.3333 5.83333 18.3333H14.1667C14.6087 18.3333 15.0326 18.1577 15.3452 17.8451C15.6577 17.5326 15.8333 17.1087 15.8333 16.6666V4.99996H4.16667ZM6.66667 4.99996V3.33329C6.66667 2.89127 6.84226 2.46734 7.15482 2.15478C7.46738 1.84222 7.89131 1.66663 8.33333 1.66663H11.6667C12.1087 1.66663 12.5326 1.84222 12.8452 2.15478C13.1577 2.46734 13.3333 2.89127 13.3333 3.33329V4.99996M8.33333 9.16663V14.1666M11.6667 9.16663V14.1666" stroke="#F04438" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

// ─── Preview sub‑components (fixed with proper state) ───────────────────────
const LogoBanner = ({ file }) => {
  const [preview, setPreview] = useState("");
  useEffect(() => {
    if (!file) {
      setPreview("");
      return;
    }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  if (!file) return null;
  return <img src={preview} alt="logo" className="oa-preview-banner-img" />;
};

const FaviconAvatar = ({ file }) => {
  const [preview, setPreview] = useState("");
  useEffect(() => {
    if (!file) {
      setPreview("");
      return;
    }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  return file ? (
    <img src={preview} alt="fav" />
  ) : (
    <span className="oa-preview-avatar-placeholder" />
  );
};

// ─── Constants ──────────────────────────────────────────────────────────────
const ALLOWED_FILE_FORMATS = ["jpg", "jpeg", "png", "svg"];

const getInitialState = () => ({
  universityName: "",
  accountType: "",
  location: "",
  email: "",
  admins: [
    { firstName: "", lastName: "", email: "", contactnumber: "" },
  ],
  logo: null,
  favicon: null,
  learningPathSharing: false,
  topicSharing: false,
  premiumFeatures: [],
  maxLearners: 1000,
  videoAttemptLimit: 25,
});

// ─── Main Component ─────────────────────────────────────────────────────────
const OnboardAccount = ({ open, setOpen }) => {
  const Alert = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const { onUploadS3Object } = useS3FileManagement();
  const {
    validateFirstName,
    validateLastName,
    validateEmail,
    validateMobile,
  } = UserValidationHook();

  const [details, setDetails] = useState(getInitialState());
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [toast, setToast] = useState({ open: false, type: "success", message: "" });

  const showToast = (type, message) => setToast({ open: true, type, message });
  const closeToast = () => setToast((prev) => ({ ...prev, open: false }));


  // Premium features from API
  const [premiumOptions, setPremiumOptions] = useState([]);
  const [expandedFeatures, setExpandedFeatures] = useState({});

  useEffect(() => {
    if (open) {
      setDetails(getInitialState());
      setErrors({});
      fetchPremiumFeatures();
      // Prevent background scroll when modal is open
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable background scroll when modal closes
      document.body.style.overflow = 'unset';
    }
    
    // Cleanup: restore scroll on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [open]);

  const fetchPremiumFeatures = async () => {
    try {
      const response = await axios.get("node/admin/premium-features");
      if (response.data?.data) {
        const formatted = response.data.data.map((item) => ({
          label: item.label,
          value: item.id,
          subFeatures: typeof item.sub_features === "string"
            ? JSON.parse(item.sub_features)
            : item.sub_features || [],
        }));
        setPremiumOptions(formatted);
        const initialExpanded = {};
        formatted.forEach((f) => { initialExpanded[f.value] = true; });
        setExpandedFeatures(initialExpanded);
      }
    } catch (err) {
      console.error("Error fetching premium features:", err);
    }
  };

  const set = (key, val) => setDetails((prev) => ({ ...prev, [key]: val }));

  // ── Admin management ───────────────────────────────────────────────────────
  const handleAddAdmin = () => {
    setDetails((prev) => ({
      ...prev,
      admins: [...prev.admins, { firstName: "", lastName: "", email: "", contactnumber: "" }],
    }));
  };

  const handleRemoveAdmin = (index) => {
    // Only allow removal of admins beyond the first two (index 0 and 1 are permanent)
    setDetails((prev) => ({
      ...prev,
      admins: prev.admins.filter((_, i) => i !== index),
    }));

    // Shift error keys for removed admin
    setErrors((prev) => {
      const newErrors = {};
      Object.entries(prev).forEach(([key, value]) => {
        const match = key.match(/^(firstName|lastName|email|contactnumber)_(\d+)$/);
        if (!match) {
          newErrors[key] = value;
          return;
        }
        const field = match[1];
        const errorIndex = parseInt(match[2], 10);
        if (errorIndex === index) return; // drop
        const newIndex = errorIndex > index ? errorIndex - 1 : errorIndex;
        newErrors[`${field}_${newIndex}`] = value;
      });
      return newErrors;
    });
  };

  const setAdminField = (index, field, val) => {
    setDetails((prev) => {
      const admins = [...prev.admins];
      admins[index] = { ...admins[index], [field]: val };
      return { ...prev, admins };
    });

    // Real-time validation for admin fields
    const errKey = `${field}_${index}`;
    const trimmed = (val || "").toString().trim();
    let errorMsg = "";
    if (field === "firstName") {
      if (!trimmed) errorMsg = "First name is required";
    } else if (field === "email") {
      if (!trimmed) {
        errorMsg = "Email is required";
      } else if (
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(trimmed)
      ) {
        errorMsg = "You have entered an invalid email!";
      }
    } else if (field === "contactnumber") {
      if (!trimmed) {
        errorMsg = "Contact number is required";
      } else if (!/^\d{10,15}$/.test(trimmed)) {
        errorMsg = "Enter a valid mobile number";
      }
    }
    setErrors((prev) => ({ ...prev, [errKey]: errorMsg }));
  };

  // ── Real‑time validation for non‑admin fields ─────────────────────────────
  const validateField = (key, value) => {
    const trimmed = (value || "").toString().trim();
    let errorMsg = "";

    if (key === "universityName") {
      if (!trimmed) errorMsg = "University name is required";
      else if (trimmed.length > 50) errorMsg = "Must be 50 characters or less";
    } else if (key === "email") {
      if (!trimmed) errorMsg = "Email is required";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) errorMsg = "Enter a valid email";
    } else if (key === "maxLearners") {
      if (!value || +value <= 0) errorMsg = "Enter valid learner count";
    } else if (key === "videoAttemptLimit") {
      if (!value || +value <= 0) errorMsg = "Enter valid attempt limit";
    }else if (key === "location") {
      if (!trimmed) errorMsg = "Location is required";
    }else if (key === "accountType") {
      if (!trimmed) errorMsg = "Account type is required";
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
  };

  const handleChange = (name, value) => {
    set(name, value);
    validateField(name, value);
  };

  // ── File upload & validation ───────────────────────────────────────────────
  const handleFileUpload = useCallback((name, file) => {
    if (!file) return;

    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!ALLOWED_FILE_FORMATS.includes(fileExtension)) {
      setErrors((prev) => ({
        ...prev,
        [name]: `Unsupported format. Allowed: ${ALLOWED_FILE_FORMATS.join(", ")}`,
      }));
      return;
    }

    setErrors((prev) => ({ ...prev, [name]: "" }));
    set(name, file);
  }, []);

  const handleRemoveFile = (field) => {
    set(field, null);
    setErrors((prev) => ({ ...prev, [field]: `${field === "logo" ? "Logo" : "Favicon"} is required` }));
  };

  // ── Drag & drop ────────────────────────────────────────────────────────────
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const makeDropHandler = useCallback(
    (field) => (e) => {
      e.preventDefault();
      e.stopPropagation();
      const droppedFile = e.dataTransfer?.files?.[0];
      if (droppedFile) handleFileUpload(field, droppedFile);
    },
    [handleFileUpload]
  );

  // ── Premium features (with sub‑features) ───────────────────────────────────
  const toggleFeatureExpand = (featureId) => {
    setExpandedFeatures((prev) => ({ ...prev, [featureId]: !prev[featureId] }));
  };

  const handleParentFeatureChange = (option) => {
    const existing = details.premiumFeatures || [];
    if (!option.subFeatures || option.subFeatures.length === 0) {
      const updated = existing.includes(option.value)
        ? existing.filter((id) => id !== option.value)
        : [...existing, option.value];
      set("premiumFeatures", updated);
      return;
    }

    const subIds = option.subFeatures.map((sub) => sub.id);
    const allSelected = subIds.every((id) => existing.includes(id));
    let updated;
    if (allSelected) {
      updated = existing.filter((id) => !subIds.includes(id));
    } else {
      updated = [...new Set([...existing, ...subIds])];
    }
    set("premiumFeatures", updated);
  };

  const handleSubFeatureChange = (subId) => {
    const existing = details.premiumFeatures || [];
    const updated = existing.includes(subId)
      ? existing.filter((id) => id !== subId)
      : [...existing, subId];
    set("premiumFeatures", updated);
  };

  // ── Full validation before submit ──────────────────────────────────────────
  const validateAll = () => {
    const e = {};
    if(!details.accountType) e.accountType = "Account type is required";
    if(!details.location?.trim()) e.location = "Location is required";
    if (!details.universityName?.trim()) e.universityName = "University name is required";
    if (!details.logo) e.logo = "Logo is required";
    if (!details.favicon) e.favicon = "Favicon is required";
    const emailErr = validateEmail(details.email);
    if (emailErr) e.email = emailErr;

    details.admins.forEach((admin, i) => {
      const fnErr = validateFirstName(admin.firstName);
      const lnErr = validateLastName(admin.lastName);
      const emErr = validateEmail(admin.email);
      const mobErr = validateMobile(admin.contactnumber);

      if (fnErr) e[`firstName_${i}`] = fnErr;
      if (lnErr) e[`lastName_${i}`] = lnErr;
      if (emErr) e[`email_${i}`] = emErr;
      if (mobErr) e[`contactnumber_${i}`] = mobErr;
    });
    const emailCounts = details.admins.reduce((acc, admin) => {
      const email = admin.email?.trim().toLowerCase();
      if (email) acc[email] = (acc[email] || 0) + 1;
      return acc;
    }, {});

    details.admins.forEach((admin, i) => {
      const email = admin.email?.trim().toLowerCase();
      if (email && emailCounts[email] > 1 && !e[`email_${i}`]) {
        e[`email_${i}`] = "Email must be unique among admins";
      }
    });
    const contactCounts = details.admins.reduce((acc, admin) => {
    const contact = admin.contactnumber?.trim();
      if (contact) acc[contact] = (acc[contact] || 0) + 1;
      return acc;
    }, {});

    details.admins.forEach((admin, i) => {
      const contact = admin.contactnumber?.trim();
      if (
        contact &&
        contactCounts[contact] > 1 &&
        !e[`contactnumber_${i}`]
      ) {
        e[`contactnumber_${i}`] =
          "Contact number must be unique among admins";
      }
    });
    if (!details.maxLearners || +details.maxLearners <= 0) {
      e.maxLearners = "Enter valid learner count";
    }

    if (!details.videoAttemptLimit || +details.videoAttemptLimit <= 0) {
      e.videoAttemptLimit = "Enter valid attempt limit";
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  // ── Submit ─────────────────────────────────────────────────────────────────
  const handleCreate = async () => {
    if (!validateAll()) {
      showToast("error", "Please fill in all required fields correctly.");
      return;
    }

    setLoading(true);
    try {
      const timestamp = Date.now();
      const files = [details.logo, details.favicon];
      const fileTypes = files.map(file => file.name.split(".").pop().toLowerCase());
      const keys = [
        `university/${details.universityName}_${timestamp}_logo.${fileTypes[0]}`,
        `university/${details.universityName}_${timestamp}_favicon.${fileTypes[1]}`,
      ];

      for (let i = 0; i < keys.length; i++) {
        await onUploadS3Object(
          keys[i],
          files[i],
          fileTypes[i],
          undefined,
          "PUT"
        );
      }
      const formData = new FormData();
      formData.append("type", details.accountType);
      formData.append("name", details.universityName);
      formData.append("logo", keys[0]);
      formData.append("favicon", keys[1]);
      formData.append("address", details.location || "");
      formData.append("contact_info", JSON.stringify({ email: details.email }));

      const adminDetails = details.admins.map((a) => ({
        firstname: a.firstName,
        lastname: a.lastName,
        email: a.email,
        mobile: a.contactnumber,
      }));
      formData.append("adminDetails", JSON.stringify(adminDetails));
      formData.append("allow_lp_sharing", details.learningPathSharing ? 1 : 0);
      formData.append("allow_topic_sharing", details.topicSharing ? 1 : 0);
      formData.append("max_learners", parseInt(details.maxLearners));
      formData.append("video_interview_attempt_limit", parseInt(details.videoAttemptLimit) || 0);
      formData.append("premium_features", JSON.stringify(details.premiumFeatures));
      formData.append("adminEmailBody", adminEmailBody);
      console.log("FormData Details : ", formData);
      const response = await axios.post("node/admin/company", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        Alert.setShowNotify({
          show: true,
          title: "Success",
          msg: response.data.msg || "University created successfully",
        });

        Alert.setFetchCompanyData((prev) => !prev);
        setOpen(false);
      } else {
        Alert.setShowNotify({
          show: true,
          title: "Error",
          msg:
            response.data.msg ||
            response.data.error ||
            "University creation failed",
        });
        if (response.data.resultCode === 2050) {
          const msg = response.data.msg;

          const emailMatch = msg.match(
            /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi
          );

          if (emailMatch?.length) {
            const errorMap = {};

            details.admins.forEach((admin, index) => {
              if (emailMatch.includes(admin.email)) {
                errorMap[`email_${index}`] =
                  "Email already assigned to another role";
              }
            });

              setErrors((prev) => ({
                  ...prev,
                  ...errorMap,
                }));
              }

          return;
        }
      }
    } catch (err) {
      Alert.setShowNotify({
        show: true,
        title: "Error",
        msg: "University creation failed",
      });
      console.error(err);
    } finally {
      setLoading(false);

    }
  };



  // ── Sidebar preview data ─────────────────────────────────────────────────
  const previewName = details.universityName || "Account Name";
  const previewEmail = details.email || "Email";
  const enabledLabels = [];

  premiumOptions.forEach((opt) => {
    // No subfeatures
    if (!opt.subFeatures?.length) {
      if (details.premiumFeatures?.includes(opt.value)) {
        enabledLabels.push(opt.label);
      }
      return;
    }

    // Get selected subfeatures
    const selectedSubs = opt.subFeatures.filter((sub) =>
      details.premiumFeatures?.includes(sub.id)
    );

    // If all selected -> show parent only
    if (selectedSubs.length === opt.subFeatures.length) {
      enabledLabels.push(opt.label);
    } else {
      // show selected subfeature labels only
      selectedSubs.forEach((sub) => {
        enabledLabels.push(sub.label);
      });
    }
  });

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <div className="oa-page">
      <div className="oa-layout">
        {/* Sidebar */}
        <aside className="oa-sidebar">
          <div className="oa-card oa-preview-card">
            <div className="oa-preview-banner">
              <LogoBanner file={details.logo} />
              <div className="oa-preview-avatar">
                <FaviconAvatar file={details.favicon} />
              </div>
            </div>
            <div className="oa-preview-body">
              <div className="oa-preview-name">{previewName}</div>
              <div className="oa-preview-status">
                <span className="oa-badge oa-badge--green">PREVIEW</span>
              </div>
              <div className="oa-preview-email">{previewEmail}</div>
              <div className="oa-preview-meta">
                <div className="oa-preview-meta-row">
                  <span className="oa-preview-meta-icon"><LocationIcon /></span>
                  <div>
                    <div className="oa-preview-meta-key">LOCATION</div>
                    <div className="oa-preview-meta-val">{details.location || "Not specified"}</div>
                  </div>
                </div>
                <div className="oa-preview-meta-row">
                  <span className="oa-preview-meta-icon"><CollegeIcon /></span>
                  <div>
                    <div className="oa-preview-meta-key">TYPE OF ACCOUNT</div>
                    <div className="oa-preview-meta-val">{details.accountType || "Not specified"}</div>
                  </div>
                </div>
                <div className="oa-preview-meta-row">
                  <span className="oa-preview-meta-icon"><FeaturesIcon /></span>
                  <div>
                    <div className="oa-preview-meta-key">ENABLED FEATURES</div>
                    <div className="oa-preview-tags">
                      {enabledLabels.length > 0
                        ? enabledLabels.slice(0, 5).map((l) => (
                          <span key={l} className="oa-badge oa-badge--brand">{l}</span>
                        ))
                        : <span className="oa-preview-meta-val">None</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </aside>

        {/* Main Content */}
        <main className="oa-main">
          {loading && <Loading />}

          {/* Account Information */}
          <div className="oa-card">
            <SectionHeader
              icon={
                <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
                  <rect x="1" y="1" width="18" height="16" rx="3" stroke="#F55533" strokeWidth="2" />
                  <path d="M1 6h18" stroke="#F55533" strokeWidth="2" />
                </svg>
              }
              title="Account Information"
            />
            <div className="oa-fields">
              <InputField
                label="Account Name"
                value={details.universityName}
                onChange={(e) => handleChange("universityName", e.target.value)}
                placeholder="University Name"
                hintText={errors.universityName}
                destructive={!!errors.universityName}
                maxLength={50}
                className="oa-label"
              />
              <div className="oa-fields-row">
                <InputDropdown
                  placement="bottom-start"
                  label="Account Type"
                  placeholder="Select account type"
                  value={details.accountType}
                  onChange={(val) => handleChange("accountType", val)}
                  options={[
                    { label: "University", value: "University" },
                    { label: "Corporate", value: "Corporate" },
                  ]}
                  className="onboard-input-dropdown"
                  hintText={errors.accountType}
                  destructive={!!errors.accountType}
                />
                <InputField
                  label="Location"
                  value={details.location}
                  onChange={(e) => handleChange("location", e.target.value)}
                  placeholder="Enter the Location"
                  hintText={errors.location}
                  destructive={!!errors.location}
                  maxLength={50}
                  className="oa-label"
                />
              </div>
              <InputField
                label="Email"
                type="email"
                value={details.email}
                leadingIcon={<EmailIcon />}
                onChange={(e) => handleChange("email", e.target.value)}
                placeholder="Enter the Email"
                hintText={errors.email}
                destructive={!!errors.email}
                className="oa-label"
              />
              <div className="oa-fields-row">
                <div className="oa-field">
                  <DragAndDropUpload
                    label="Account Logo"
                    text="Drag & Drop your logo"
                    supportFormat={".jpg, .jpeg, .png"}
                    file={details.logo}
                    onUpload={(event) => handleFileUpload("logo", event.target.files[0])}
                    onDragOver={handleDragOver}
                    onDrop={makeDropHandler("logo")}
                    onRemoveFile={() => handleRemoveFile("logo")}
                    isDeletable={true}
                    destructive={!!errors.logo}
                    hintText={errors.logo}
                    button={
                      <Button size="sm" hierarchy={{ type: "secondaryGrey" }} icon={{ icon: <UploadImage />, type: "leading" }} />
                    }
                  />
                </div>
                <div className="oa-field">
                  <DragAndDropUpload
                    label="Favicon"
                    text="Drag & Drop your favicon"
                    supportFormat={".jpg, .jpeg, .png"}
                    file={details.favicon}
                    onUpload={(event) => handleFileUpload("favicon", event.target.files[0])}
                    onDragOver={handleDragOver}
                    onDrop={makeDropHandler("favicon")}
                    onRemoveFile={() => handleRemoveFile("favicon")}
                    isDeletable={true}
                    destructive={!!errors.favicon}
                    hintText={errors.favicon}
                    button={
                      <Button size="sm" hierarchy={{ type: "secondaryGrey" }} icon={{ icon: <UploadImage />, type: "leading" }} />
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Admin Details */}
          <div className="oa-card">
            <SectionHeader
              icon={
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
                  <path d="M9 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM1 19c0-4 3.582-7 8-7s8 3 8 7" stroke="#F55533" strokeWidth="2" strokeLinecap="round" />
                </svg>
              }
              title="Admin Details"
            />
            <div className="oa-admins-list">
              <div className="oa-admins-grid">
                {details.admins.map((admin, index) => (
                  <div key={index} className="oa-admin-col">
                    <div className="oa-admin-header">
                      <span>{admin.type || `Admin ${index + 1}`}</span>
                      {/* Delete only for admins beyond the first two (index > 1) */}
                      {index > 0 && (
                        // <Button
                        //   size="sm"
                        //   onClick={() => handleRemoveAdmin(index)}
                        //   hierarchy={{ type: "tertiaryGrey", buttonText: "Delete" }}
                        //   destructive
                        //   icon={{ type: "leading", icon: <DeleteIconSvg />, nospace: true }}
                        // />
                        <IconButton
                          size="sm"
                          onClick={() => handleRemoveAdmin(index)}
                          hierarchy="secondaryGrey"
                        >
                          <DeleteIconSvg />
                        </IconButton>
                      )}
                    </div>

                    <div className="oa-admin-grid">
                      <InputField
                        label="First Name"
                        value={admin.firstName}
                        onChange={(e) => setAdminField(index, "firstName", e.target.value)}
                        placeholder="Enter First Name"
                        hintText={errors[`firstName_${index}`]}
                        destructive={!!errors[`firstName_${index}`]}
                        className="oa-label"
                      />
                      <InputField
                        label="Last Name"
                        value={admin.lastName}
                        onChange={(e) => setAdminField(index, "lastName", e.target.value)}
                        placeholder="Enter Last Name"
                        hintText={errors[`lastName_${index}`]}
                        destructive={!!errors[`lastName_${index}`]}
                        className="oa-label"
                      />
                    </div>
                    <div className="oa-admin-name-row">
                      <InputField
                        label="Email-ID"
                        type="email"
                        value={admin.email}
                        onChange={(e) => setAdminField(index, "email", e.target.value)}
                        placeholder="Enter Admin Email"
                        hintText={errors[`email_${index}`]}
                        destructive={!!errors[`email_${index}`]}
                        className="oa-label"
                      />
                      <div className="oa-phone-field">
                        <label className="oa-label" style={{ margin: "0" }}>Contact Number</label>
                        <PhoneInput
                          placeholder="Enter Number"
                          onlyCountries={["us", "in"]}
                          country="in"
                          value={admin.contactnumber || ""}
                          onChange={(value) => setAdminField(index, "contactnumber", value)}
                          containerClass={errors[`contactnumber_${index}`] ? "has-error" : ""}
                          countryCodeEditable={false}
                        />
                        {errors[`contactnumber_${index}`] && (
                          <span className="oa-hint oa-hint--error">
                            {errors[`contactnumber_${index}`]}
                          </span>
                        )}
                      </div>
                    </div>
                    {index < details.admins.length - 1 && <div className="oa-admin-divider" />}
                  </div>
                ))}
              </div>
              <div style={{ display: "flex" }}>
                <Button
                  size="sm"
                  onClick={handleAddAdmin}
                  icon={{
                    type: "leading",
                    icon: <AddadminplusIcon />,
                  }}
                  hierarchy={{ type: "linkGrey", buttonText: " Add Admin" }}
                />
              </div>
            </div>
          </div>

          {/* Platform Settings */}
          <div className="oa-card">
            <SectionHeader
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#F55533" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              }
              title="Platform Settings"
            />
            <div className="oa-platform-grid">
              <div className="oa-platform-left">
                <ToggleButton
                  text="Learning Path Sharing:"
                  pressed={details.learningPathSharing}
                  onChange={(val) => handleChange("learningPathSharing", val)}
                  size="sm"
                  theme="Dark"
                />
                <div className="oa-features-block">
                  <div className="oa-features-label">Premium Features:</div>
                  <div className="oa-features-list">
                    {premiumOptions.map((option) => {
                      const subIds = option.subFeatures?.map((s) => s.id) || [];
                      const isParentSelected = subIds.length
                        ? subIds.some((id) => details.premiumFeatures?.includes(id))
                        : details.premiumFeatures?.includes(option.value);

                      const isParentChecked = option.subFeatures?.length
                        ? option.subFeatures.some((sub) =>
                          details.premiumFeatures?.includes(sub.id)
                        )
                        : details.premiumFeatures?.includes(option.value);

                      return (
                        <div className="oa-feature-group">
                          <div className="oa-feature-parent">
                            <div className="oa-feature-row">

                              <Checkbox
                                checked={isParentChecked}
                                onChange={() => handleParentFeatureChange(option)}
                              />

                              {option.subFeatures?.length > 0 && (
                                <button
                                  type="button"
                                  className="oa-feature-expand-btn"
                                  onClick={() => toggleFeatureExpand(option.value)}
                                >
                                  {expandedFeatures[option.value] ? "−" : "+"}
                                </button>
                              )}

                              <span className="oa-feature-title">
                                {option.label}
                              </span>
                            </div>

                            {expandedFeatures[option.value] &&
                              option.subFeatures?.length > 0 && (
                                <div className="oa-subfeatures">
                                  {option.subFeatures.map((sub) => (
                                    <div key={sub.id} className="oa-subfeature-row">
                                      <Checkbox
                                        checked={details.premiumFeatures?.includes(sub.id)}
                                        onChange={() => handleSubFeatureChange(sub.id)}
                                      />

                                      <span>{sub.label}</span>
                                    </div>
                                  ))}
                                </div>
                              )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="oa-platform-right">
                <ToggleButton
                  text="Topic Sharing:"
                  pressed={details.topicSharing}
                  onChange={(val) => handleChange("topicSharing", val)}
                  size="sm"
                  theme="Dark"
                />
                <div className="oa-limits-label">Limits & Configuration</div>
                <InputField
                  label="Maximum Learners:"
                  type="number"
                  value={details.maxLearners}
                  onChange={(e) => handleChange("maxLearners", e.target.value)}
                  placeholder="178"
                  hintText={errors.maxLearners}
                  destructive={!!errors.maxLearners}
                  className="oa-label--dark"
                />
                <InputField
                  label="Video Interview attempt limit:"
                  type="number"
                  value={details.videoAttemptLimit}
                  onChange={(e) => handleChange("videoAttemptLimit", e.target.value)}
                  hintText={errors.videoAttemptLimit}
                  destructive={!!errors.videoAttemptLimit}
                  placeholder="6"
                  className="oa-label--dark"
                />
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="oa-actions">

            <Button
              size="lg"
              hierarchy={{ type: "primary", buttonText: "Create Account" }}
              onClick={handleCreate}
              className="oa-create-btn"
              disabled={loading}
            />
          </div>
        </main>
      </div>
      <Toast
        open={toast.open}
        type={toast.type}
        message={toast.message}
        onClose={closeToast}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </div>
  );
};

export default OnboardAccount;
